export enum PublisherSideBarState {
    addAP,
    addOP,
    editOP,
    addWriterOp,
    empty,
}
